import { Container } from "@mui/material";
import React, { Suspense } from "react";
import { NavLink, Outlet } from "react-router-dom";

// import { Circles } from "react-loader-spinner";
function CommonContainer({ SUBNAV, children, TITLE,MAINTITLE }: any) {
  return (
    <div className="common_container">
      <header>
        <h3>{MAINTITLE}</h3>
        <div className="tabbar_container">
          {children ?? <div></div>}
          <div className="routes">
            {SUBNAV
              ? SUBNAV?.map((ITEM: any, i: number) => {
                  if (!ITEM.PATH.includes(":")) {
                    return (
                      <NavLink
                        key={i}
                        to={ITEM.PATH}
                        className={({ isActive }) =>
                          isActive ? "nav-list nav-list-active" : "nav-list"
                        }
                      >
                        {ITEM.TITLE}
                      </NavLink>
                    );
                  }
                  return null;
                })
              : null}
          </div>
        </div>
      </header>
      <Outlet />
    </div>
  );
}

export default CommonContainer;
